<form class="filter-form" [formGroup]="waterLevelForm">
    <h3 class="text-center">પસંદગી કરો</h3>
    <div class="form-group">
        <mat-form-field class="example-full-width w-100" appearance="outline">
            <input type="text" placeholder="Select Water Level" aria-label="text" name="business"
                 matInput formControlName="waterLevel" [matAutocomplete]="auto">
            <mat-autocomplete autoActiveFirstOption #auto="matAutocomplete">
                <mat-option *ngFor="let data of waterLevel" [value]="data.value">
                    {{data.label}}
                </mat-option>
            </mat-autocomplete>
            <mat-icon matSuffix>arrow_drop_down</mat-icon>
        </mat-form-field>
    </div>
    <div class="row">
        <div class="col-6">
            <div class="form-group">
                <button type="reset" class="btn-common w-100 closeBtn" (click)="Cancel()">રદ કરો</button>
            </div>
        </div>
        <div class="col-6">
            <div class="form-group">
                <button type="submit" class="btn-common w-100" (click)="submit()">પસંદ કરો</button>
            </div>
        </div>
    </div>
</form>